import React from 'react';
import { concatStyles } from 'utils';
var ACCESSORY_LABEL_STYLES = 'flex my-auto mr-3 mb-0 md: xl:flex text-xs truncate p-0 m-0';
export var AccessoryLabel = function (_a) {
    var compact = _a.compact, children = _a.children;
    return (React.createElement("span", { className: concatStyles([ACCESSORY_LABEL_STYLES, compact ? 'hidden' : '']) }, children));
};
